import React from 'react';
import { Card, Label } from 'semantic-ui-react';
import UserImage from './UserImage';

const UserCard = (
  {
    unreadNotifications,
    name,
    subtitle,
  },
) => (
  <Card className="aridhia-user-card">
    <Card.Content>
      <UserImage name={name} size="mini" floated="right" className="aridhia-avatar" />
      {unreadNotifications > 0 && (<Label floating color="blue">{unreadNotifications}</Label>)}
      <div className="flex flex-column mr-20">
        <Card.Header content={name} className="aridhia-user-card-header mb-5" />
        <Card.Meta content={subtitle} className="aridhia-user-card-meta" />
      </div>
    </Card.Content>
  </Card>
);

export default UserCard;
